module.exports = "../study/imgs/maps/Nagano/S8/Climate/Precipitation/Nagano_Precipitation_MRI_RCP45_End.png";